
import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setTimeout(() => {
        setEmail('');
        setSubscribed(false);
      }, 3000);
    }
  };

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo e Newsletter */}
          <div className="lg:col-span-1">
            <img 
              src="https://static.readdy.ai/image/c613884721c0b6590a025a9d6892fb89/e6306d29b4b79d9c756a82fe44d7def5.png" 
              alt="Sete Nove Imóveis" 
              className="h-10 w-auto mb-4 brightness-0 invert"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
            <p className="text-gray-300 mb-4 text-sm">
              Imóveis de médio e alto padrão em Aracaju e Barra dos Coqueiros
            </p>
            <form onSubmit={handleNewsletterSubmit} className="flex gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Seu e-mail"
                className="flex-1 px-3 py-2 text-sm rounded-lg bg-white/10 border border-white/20 text-white placeholder-gray-400 focus:outline-none focus:border-orange-500 transition-colors"
                required
              />
              <button
                type="submit"
                className="bg-orange-500 px-4 py-2 rounded-lg hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                {subscribed ? (
                  <i className="ri-check-line"></i>
                ) : (
                  <i className="ri-send-plane-fill"></i>
                )}
              </button>
            </form>
          </div>

          {/* Navegação */}
          <div>
            <h3 className="font-bold text-lg mb-4">Navegação</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="/imoveis"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Imóveis
                </a>
              </li>
              <li>
                <a
                  href="/comprar-imovel-sergipe"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Comprar Imóvel
                </a>
              </li>
              <li>
                <a
                  href="/vender-imovel-sergipe"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Vender Imóvel
                </a>
              </li>
              <li>
                <a
                  href="/avaliar-imovel"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Avaliar Imóvel
                </a>
              </li>
              <li>
                <a
                  href="/videos"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Vídeos
                </a>
              </li>
              <li>
                <a
                  href="/sobre"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Sobre
                </a>
              </li>
              <li>
                <a
                  href="/contato"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Contato
                </a>
              </li>
            </ul>
          </div>

          {/* Regiões */}
          <div>
            <h3 className="font-bold text-lg mb-4">Regiões</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/imoveis/aracaju"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Imóveis em Aracaju
                </Link>
              </li>
              <li>
                <Link
                  to="/imoveis/barra-dos-coqueiros"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Imóveis em Barra dos Coqueiros
                </Link>
              </li>
              <li>
                <Link
                  to="/imoveis?bairro=Atalaia"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Atalaia
                </Link>
              </li>
              <li>
                <Link
                  to="/imoveis?bairro=Coroa do Meio"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Coroa do Meio
                </Link>
              </li>
              <li>
                <Link
                  to="/imoveis?bairro=Jardins"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Jardins
                </Link>
              </li>
              <li>
                <Link
                  to="/imoveis?bairro=Farolândia"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Farolândia
                </Link>
              </li>
              <li>
                <Link
                  to="/imoveis?bairro=Grageru"
                  className="text-gray-300 hover:text-orange-500 transition-colors cursor-pointer"
                >
                  Grageru
                </Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="font-bold text-lg mb-4">Contato</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="https://wa.me/5579999881002"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-green-400 hover:text-green-300 transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-fill text-lg"></i>
                  (79) 99988-1002
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-300">
                <i className="ri-mail-fill"></i>
                contato@setenoveimoveis.com
              </li>
              <li className="flex items-start gap-2 text-gray-300">
                <i className="ri-map-pin-fill mt-1"></i>
                <span>
                  Aracaju e Barra dos Coqueiros - Sergipe
                </span>
              </li>
              <li className="flex gap-3 mt-4">
                <a
                  href="https://www.instagram.com/setenoveimoveis"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-orange-500 transition-colors cursor-pointer"
                  title="Instagram"
                >
                  <i className="ri-instagram-fill"></i>
                </a>
                <a
                  href="https://www.tiktok.com/@setenoveimoveis"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-orange-500 transition-colors cursor-pointer"
                  title="TikTok"
                >
                  <i className="ri-tiktok-fill"></i>
                </a>
                <a
                  href="https://www.youtube.com/@setenoveimoveis"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 flex items-center justify-center bg-white/10 rounded-full hover:bg-orange-500 transition-colors cursor-pointer"
                  title="YouTube"
                >
                  <i className="ri-youtube-fill"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-400">
              © 2025 Sete Nove Imóveis. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/admin/login"
                className="text-sm text-slate-400 hover:text-white transition-colors cursor-pointer flex items-center gap-2"
              >
                <i className="ri-lock-line"></i>
                Área Restrita
              </Link>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-slate-400 hover:text-white transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
